import { cn } from '@/lib/utils';
import { Body } from '@e2n/ui/v2';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { faPlus } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ButtonHTMLAttributes } from 'react';

type CardButtonProps = Omit<
  ButtonHTMLAttributes<HTMLButtonElement>,
  'children'
> & {
  label: string;
  icon: IconDefinition;
  iconClassName?: string;
};

export function CardButton({
  label,
  icon,
  iconClassName,
  className,
  type = 'button',
  ...props
}: CardButtonProps) {
  return (
    <button
      type={type}
      className={cn(
        'group flex w-full items-center gap-3 rounded-xl bg-neutrals-v2-200 p-3 text-left cursor-pointer hover:bg-neutrals-v2-300 disabled:cursor-not-allowed disabled:opacity-50',
        className,
      )}
      {...props}>
      <span className="flex size-9 shrink-0 items-center justify-center rounded-lg bg-white text-brand-red-200">
        <FontAwesomeIcon icon={icon} className={cn('size-6', iconClassName)} />
      </span>
      <Body weight="semibold" className="flex-1 min-w-0 wrap-break-word">
        {label}
      </Body>
      <span className="flex size-9 shrink-0 items-center justify-center rounded-lg bg-neutrals-v2-200 text-brand-blue-100 group-hover:bg-neutrals-v2-300">
        <FontAwesomeIcon icon={faPlus} className="size-5" />
      </span>
    </button>
  );
}
